import { convertLexicalToHTML } from '@payloadcms/richtext-lexical/html'
import { removeInvalidLiValueAttributes } from '@/lib/lexical'

interface RichTextProps {
 content: any
 className?: string
}

export function RichText({ content, className }: RichTextProps) {
 const processedContent = processInternalLinks(content)
 const html = removeInvalidLiValueAttributes(convertLexicalToHTML({ data: processedContent, disableContainer: true }))
 
 return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />
}

function processInternalLinks(data: any) {
 if (!data?.root?.children) return data
 
 function processNode(node: any) {
   if (node.type === 'link' && node.fields) {
     if (node.fields.linkType === 'internal' && node.fields.doc?.value?.slug) {
       return {
         ...node,
         fields: {
           ...node.fields,
           url: `/${node.fields.doc.value.slug}`,
           linkType: 'custom'
         }
       }
     }
     
     if (node.fields.linkType === 'custom' && node.fields.url) {
       return node
     }
   }
   
   if (node.children) {
     return {
       ...node,
       children: node.children.map(processNode)
     }
   }
   
   return node
 }
 
 return {
   ...data,
   root: {
     ...data.root,
     children: data.root.children.map(processNode)
   }
 }
}